{
  "captchaHint": "Enter the captcha to start calling",
  "verify": "Verify",
  "invalidCaptcha": "Invalid captcha, please try again",
  "expiresIn": "Expires in",
  "expiredHint": "Authorization expired, please verify again",
  "browser": {
    "title": "Notice",
    "versionHint": "Please use Chrome 72, Edge 79, Firefox 65, or Safari 12 (or later) to ensure proper operation.",
    "unsupportedHint": "This browser does not support the features required for calling. Please use a newer version of Chrome, Edge, Firefox, or Safari.",
    "insecureHint": "Please open this page over a secure https connection to use calling."
  }
}